<template>
  <div class="work container">
    <transition name="slide-fade-work" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'work-index'
}
</script>

<style lang="sass">

.project
  width: 100%

.project-gallery
  width: 100%

</style>



// WEBPACK FOOTER //
// Index.vue?48db70ea